<template>
    <div class="bottomTitle">
        <div v-for="item in obj" :key="item.name">
            <img :src=item.img alt="">
            <p>{{item.name}}</p>
            <span>{{item.title}}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Array,
      default: "没有数据"
    }
  }
};
</script>
<style lang='less' scoped>
.bottomTitle {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 62px;
    > img {
      margin-bottom: 24px;
    }
    > p {
      height: 29px;
      line-height: 29px;
      font-size: 28px;
      color: #000;
      margin-bottom: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue